import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  BookOpen, Users, Newspaper, Star, Handshake, Image as ImageIcon,
  Wallet, Mail, GraduationCap, TrendingUp, Video, Instagram, Megaphone, MessageCircle,
} from "lucide-react";
import api from "../../lib/api";

const cards = [
  { key: "courses", icon: BookOpen, label: "Courses", to: "/admin/courses", color: "bg-yellow-400 text-[#0B2A6B]" },
  { key: "banners", icon: ImageIcon, label: "Banners", to: "/admin/banners", color: "bg-[#0B2A6B] text-yellow-400" },
  { key: "ticker", icon: Megaphone, label: "Ticker", to: "/admin/ticker", color: "bg-yellow-400 text-[#0B2A6B]" },
  { key: "videos", icon: Video, label: "Videos", to: "/admin/videos", color: "bg-[#0B2A6B] text-yellow-400" },
  { key: "instagram", icon: Instagram, label: "Instagram", to: "/admin/instagram", color: "bg-yellow-400 text-[#0B2A6B]" },
  { key: "faculty", icon: Users, label: "Faculty", to: "/admin/faculty", color: "bg-[#0B2A6B] text-yellow-400" },
  { key: "news", icon: Newspaper, label: "News Items", to: "/admin/news", color: "bg-yellow-400 text-[#0B2A6B]" },
  { key: "testimonials", icon: Star, label: "Testimonials", to: "/admin/testimonials", color: "bg-[#0B2A6B] text-yellow-400" },
  { key: "partners", icon: Handshake, label: "Partners", to: "/admin/partners", color: "bg-yellow-400 text-[#0B2A6B]" },
  { key: "financial_aid", icon: Wallet, label: "Financial Aid", to: "/admin/financial-aid", color: "bg-[#0B2A6B] text-yellow-400" },
];

export default function AdminDashboard() {
  const [s, setS] = useState({});

  useEffect(() => {
    api.get("/admin/summary").then((r) => setS(r.data));
  }, []);

  return (
    <div>
      <h2 className="text-2xl font-bold text-[#0B2A6B] mb-1">Dashboard</h2>
      <p className="text-slate-500 mb-7">Overview of your website content & enquiries.</p>

      {/* Hot stats */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-8">
        <HotCard
          to="/admin/admissions"
          icon={GraduationCap}
          label="New Admissions"
          value={s.admissions_new || 0}
          total={s.admissions_total || 0}
          accent="yellow"
        />
        <HotCard
          to="/admin/contacts"
          icon={Mail}
          label="Unread Messages"
          value={s.contacts_unread || 0}
          total={s.contacts_total || 0}
          accent="blue"
        />
        <HotCard
          to="/admin/chat-leads"
          icon={MessageCircle}
          label="Chat Leads"
          value={s.chat_leads || 0}
          accent="yellow"
        />
        <HotCard
          to="/admin/courses"
          icon={BookOpen}
          label="Total Courses"
          value={s.courses || 0}
          accent="blue"
        />
      </div>

      <h3 className="text-lg font-bold text-[#0B2A6B] mb-4">Manage Content</h3>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-5">
        {cards.map((c) => (
          <Link key={c.key} to={c.to} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 hover:shadow-lg hover:-translate-y-1 transition group">
            <div className={`h-12 w-12 rounded-xl ${c.color} flex items-center justify-center mb-3 group-hover:scale-110 transition`}>
              <c.icon className="h-6 w-6" />
            </div>
            <div className="text-3xl font-bold text-[#0B2A6B]">{s[c.key] || 0}</div>
            <p className="text-sm text-slate-500 mt-1">{c.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

function HotCard({ to, icon: Icon, label, value, total, accent }) {
  return (
    <Link
      to={to}
      className={`relative overflow-hidden rounded-2xl p-6 shadow-sm border ${
        accent === "yellow" ? "bg-yellow-50 border-yellow-200" : "bg-[#0B2A6B] text-white border-[#0B2A6B]"
      } hover:shadow-lg hover:-translate-y-1 transition group`}
    >
      <div className="h-11 w-11 rounded-xl flex items-center justify-center mb-3 bg-yellow-400 text-[#0B2A6B]">
        <Icon className="h-5 w-5" />
      </div>
      <div className={`text-4xl font-bold ${accent === "yellow" ? "text-[#0B2A6B]" : "text-yellow-400"}`}>{value}</div>
      <p className={`text-sm mt-1 ${accent === "yellow" ? "text-slate-600" : "text-slate-200"}`}>
        {label}
        {total !== undefined && <span className="ml-1 opacity-70">/ {total} total</span>}
      </p>
      <TrendingUp className={`absolute right-4 bottom-4 h-10 w-10 opacity-10 ${accent === "yellow" ? "text-[#0B2A6B]" : "text-yellow-400"}`} />
    </Link>
  );
}
